import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AcessoModulosService } from '../../shared/services/acesso-modulos/acesso-modulos.service';

/**
 * Valida, na navegação, se o módulo da rota /modulos/:modulo é permitido para o
 * grupo do usuário — inclusive quando a URL é digitada direto.
 *
 * Não substitui e não altera o AuthGuardService: a autenticação continua sendo
 * validada por ele; aqui só o acesso ao módulo (mock temporário) é checado.
 */
@Injectable({
  providedIn: 'root',
})
export class ModuloAcessoGuardService implements CanActivate {
  constructor(
    private router: Router,
    private acessoModulosService: AcessoModulosService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const permitido = await this.acessoModulosService.podeAcessarModulo(
      route.paramMap.get('modulo'),
    );

    if (!permitido) {
      void this.router.navigate(['/home']);
      return false;
    }

    return true;
  }
}
